import {FACTIONS} from "../../../constants/factions";

export const HUMANS_QUOTES = [{
  quote: 'Орк сильнее. Эльф быстрее. Но только человек проснётся завтра с новым планом, а они — с теми же мышцами',
  author: 'Тиберий Корв, полководец и идейный лидер Вольных Городов',
  factionId: FACTIONS.HUMANS,
}, {
  quote: 'Глупый полководец ищет лучшую армию. Умный — лучшую завтрашнюю армию',
  author: 'Луций Варрон, прославленный наёмный стратег',
  factionId: FACTIONS.HUMANS,
}, {
  quote: 'У людей нет клыков, когтей, крыльев. У нас есть память. И мы помним всё. Особенно обиды',
  author: 'Гай Азиний Поллион, наместник-пропретор Возрожденного Рима',
  factionId: FACTIONS.HUMANS,
}, {
  quote: 'Быть гибким — значит согнуться, но не сломаться',
  author: 'Тит Витразий Поллион, известный на весь человеческий мир оратор Возрожденного Рима',
  factionId: FACTIONS.HUMANS,
}, {
  quote: 'Жребий брошен — но кости всегда на стороне тьмы',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Горе побеждённым',
  author: 'Бренн, вождь галльского племени сенонов',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Мёртвые знают только одно слово — "никогда"',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Никогда не сражайся с одним и тем же врагом дважды — он выучит твои приёмы',
  author: 'Сципион Африканский, римский военноначальник и политик',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война кормится войной',
  author: 'Ливий Андроник, римский драматург и поэт',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Пусть ненавидят, лишь бы боялись',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Что бы ни случилось, считай, что это суждено',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Пусть они ненавидят — лишь бы боялись',
  author: 'Луций Акций, римский поэт',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Хочешь мира — готовься к войне, но помни: боги любят того, кто может и то, и другое',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Лучше вовремя отступить в болота, чем победить, а после лечь в них самому',
  author: 'Квинт Серторий, римский политик и военачальник',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Крепость берут не стены, а голод внутри',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Не презирай в бою нищего с ножом — у него нет ничего, кроме желания забрать твоё',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Дорога стоит больше, чем сто легионов. Без неё золото не придёт, а враг придёт',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Хлеб и зрелища — это дешёво. Священный ужас — вот что удерживает империю',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Кто не умеет считать припасы в мирное время, тот будет считать трупы в военное',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Помни: вчерашний союзник сегодня молчит там, где мог бы крикнуть. Это первый шаг к твоей гибели',
  author: 'Марк Тулий Цицерон,  римский государственный и политический деятель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Лучше один враг, боящийся тебя, чем десять друзей, которым ты должен',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война — не продолжение политики. Политика — это передышка между войнами',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Каждый легион носит внутри себя свою будущую гибель. Обычно — в виде обоза с золотом',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Ни одна победа не бывает окончательной. Окончательной бывает только тишина после неё',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Все здесь, кто намерен сражаться',
  author: 'Миронид, афинский военачальник времен Пелопонесской войны',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'На войне нет места для двух ошибок',
  author: 'Ламах, афинский стратег времен Пелопонесской войны',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война — дело не столько оружия, сколько денег',
  author: 'Фукидид, древнегреческий историк',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я помню о человеческой слабости, размышляю о мощи Фортуны и знаю: всё, что мы делаем, подвержено тысяче случайностей',
  author: 'Сципион Африканский, римский военноначальник и политик',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я не боюсь армии львов, ведомой овцой. Я боюсь армии овец, ведомой львом',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я либо найду способ, либо сделаю его сам',
  author: 'Ганнибал Барка, карфагенский военноначальник',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Мы найдём дорогу, но если нам это не удастся, мы построим её сами',
  author: 'Ганнибал Барка, карфагенский военноначальник',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Кто удивил, тот победил',
  author: 'Ганнибал Барка, карфагенский военноначальник',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Ещё одна такая победа, и я погиб',
  author: 'Пирр Эпирский, царь Эпира и Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Высшее достижение — победить неприятеля, не переходя к бою',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Построй врагу золотой мост для отступления',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Полководец — это судьба государства. Если он может управлять армией и добиться победы, государство будет в безопасности',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Армия, которая не грабит обоз врага, — уже мертва. Она просто ещё не знает об этом',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Пыль в глаза врага дороже золота в своей казне',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Не тот император велик, у кого много земель, а тот, кто ни одной не потерял по своей глупости',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Победа — дочь не храбрости, но терпения и гнили в стане врага',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Когда не знаешь, что делать — делай то, чего враг от тебя не ждёт. Даже глупость, если она неожиданна, становится гениальностью',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я не заинтересован в понимании овец. Я просто их ем',
  author: 'Ганнибал Барка, карфагенский военноначальник',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Полководец, который не умеет ждать, не умеет побеждать. Но тот, кто ждёт слишком долго, умирает от рук своих же солдат',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Человеку достаточно одного коня, чтобы убежать от смерти. Но если смерть решила взять тебя — не поможет и тысяча',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Самая сладкая победа — та, где враг не понял, что проиграл, пока не увидел свою голову у тебя в руке',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война не заканчивается, когда умирает последний враг. Война заканчивается, когда умирает память о нём',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Холод убивает армии медленнее, чем голод. А голод — медленнее, чем глупость командира',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Лучший манёвр — тот, о котором враг узнаёт за миг до того, как твоя стрела войдёт ему в глаз',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Чужая земля не прокормит армию дольше одного сезона. Своя — прокормит вечность. Поэтому воюем там, где умрём, или дома',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Победы может добиться лишь тот, кто в нее верит',
  author: 'Никиф Фракийский, император-полководец Эстафии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Вопрос не в том, добьетесь ли вы успеха. Вопрос-то в том, верите ли вы в него',
  author: 'Флав Лизарий, командующий шестого легиона Вольных городов',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война – это место, где встречаются жизнь и смерть',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Длительная кампания истощает государственные ресурсы',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Пока вы не уверены в победе, защищайтесь',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Военная стратегия – как вода, потоки которой стекают с высоты вниз',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Встречаются дороги, по которым лучше не ходить; встречаются армии, которые никто не атакует',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Командующий, который недооценивает неприятеля, попадает в плен',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Сущность военных действий заключается в быстроте',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Правитель не должен приказывать своему командующему двинуть армию просто из чувства гнева',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Успешная война идет дорогой обмана',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'В войне главное – победа, а не продолжительность кампании',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Великие военачальники прошлого сначала сами старались избежать поражения, а затем ждали, когда неприятель почувствует себя уязвимым',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Мудрый правитель действует осторожно, а хороший командующий ведет себя бдительно',
  author: 'Сунь-Цзы, китайский стратег и мыслитель',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: '– Что же, царь, оставляешь ты себе? – Надежду',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Как я был бы счастлив, если бы меня убили в бою. Было бы гораздо благороднее умереть жертвой врага, чем жертвой гнева своих друзей',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Не может быть двух солнц на небе и двух владык на земле',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Нет ничего невозможного для тех, кто пытается',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я не краду победу',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Ни одна крепость не является настолько неприступной, что мул, нагруженный золотом, не может войти в нее',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Во вселенной бессчетное множество миров, а мы еще и одного не завоевали?',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Слава венчает действия тех, кто подвергается опасности',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я бодрствовал затем, чтобы вы могли спокойно спать',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Нет ничего более рабского, чем роскошь и нега, и ничего более царственного, чем труд',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'В конце концов, когда все закончится, единственное, что имеет значение, это то, что вы сделали',
  author: 'Александр Великий, царь Македонии',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Или власть немногого достойна, или власти немногие достойны',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Жизнь человеческая подобна железу. Если употреблять его в дело, оно истирается, если же не употреблять, ржавчина его съедает',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Говоря с мудрым, употребляй немного слов',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Я говорю лишь тогда, когда убежден, что молчать нет смысла',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Кто пустым делам придает важность, тот в важных делах окажется пустым человеком',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Царь – животное плотоядное',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Тот, кто бьет жену или ребенка, поднимает руку на самую высокую святыню',
  author: 'Марк Порций Катон',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Либо победить, либо умереть свободными',
  author: 'Гней Помпей Великий, римский государственный деятель и полководец',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Задача полководца – побеждать столько же умом, сколько мечом',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Счастье во всем играет большую роль, особенно же в делах войны',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Никакая победа не принесет столько, сколько может отнять одно поражение',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Великие дела надо совершать не раздумывая, чтобы мысль об опасности не ослабляла отвагу и быстроту',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Оратор должен избегать лишних слов, как рулевой избегает подводных камней',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Опыт – всему учитель',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Люди охотно верят тому, чему желают верить',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Пришел, увидел, победил',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Правителя не так легко столкнуть с первого места на второе, как потом со второго на последнее',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Война дает право завоевателям диктовать покоренным любые условия',
  author: 'Гай Юлий Цезарь, первый император Рима',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Тот, кто желает построить армию, должен начать с желудка',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Как бы плохо не приходилось, никогда не отчаивайся, держись, пока силы есть',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Одна минута решает исход битвы, один час – успех кампании, один день – судьбу империи',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Два хозяина в одном дому быть не могут',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Быстрота и натиск – душа настоящей войны',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Ненависть затмевает рассудок',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Удача следует за великим человеком',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Народ, не желающий кормить свою армию, вскоре будет вынужден кормить чужую',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Вы хотите узнать, надежны ли ваши друзья? Для сего надобно оказаться в несчастии',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Не ищите злой умысел там, где все можно объяснить глупостью',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'От великого до смешного только один шаг',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Вернейший способ сдержать слово – не давать его',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Когда неприятель делает ошибку, не следует ему мешать',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Голова без памяти – все равно что крепость без гарнизона',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Гений состоит в умении отличать трудное от невозможного',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}, {
  quote: 'Если вы идете сквозь ад, не останавливайтесь',
  author: 'древняя мудрость',
  factionId: FACTIONS.HUMANS,
  realQuote: true,
}]